// extracted by mini-css-extract-plugin
var _1 = "circle-529d3";
var _2 = "custom-scroll-529d3";
var _3 = "display-settings__body-529d3";
var _4 = "display-settings__header-529d3";
var _5 = "grey-529d3";
var _6 = "hidden-scroll-529d3";
var _7 = "settings__description-529d3";
var _8 = "settings__label-529d3";
var _9 = "settings__subtitle-529d3";
var _a = "toggler-529d3";
var _b = "toggler_active-529d3";
var _c = "toggler_disabled-529d3";
var _d = "tutorial-scroll-529d3";
var _e = "wide-scroll-529d3";
export { _1 as "circle", _2 as "custom-scroll", _3 as "display-settings__body", _4 as "display-settings__header", _5 as "grey", _6 as "hidden-scroll", _7 as "settings__description", _8 as "settings__label", _9 as "settings__subtitle", _a as "toggler", _b as "toggler_active", _c as "toggler_disabled", _d as "tutorial-scroll", _e as "wide-scroll" }
